var factory = {};
export {
  factory as __exports
};
//# sourceMappingURL=factory.js.map
